// extracted by css-extract-rspack-plugin
export default {"landingItems":"_84f516b","landingItem":"_1a571d78","isHorizontal":"_211690ae","smallLandingItem":"_bfd3a47"};